import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NovoDiario from "./pages/NovoDiario";
import Legal from "./pages/Legal";
import Ativar from "./pages/Ativar";
import RedefinirSenha from "./pages/RedefinirSenha";
import Paciente from "./pages/Paciente";
import Plano from "./pages/Plano";
import Admin from "./pages/Admin";
import SeoToolPage from "./pages/SeoToolPage";

const Acompanhamento = lazy(() => import("./pages/Acompanhamento"));

function Protected({ children }) {
  const { user, loading } = useAuth();
  return loading ? <div className="estado-pagina">Carregando…</div> : user ? children : <Navigate to="/entrar" replace />;
}

function PlanRequired({ children }) {
  const { user, loading } = useAuth();
  const [checking, setChecking] = useState(true);
  const [active, setActive] = useState(false);
  useEffect(() => {
    let mounted = true;
    if (!loading && user) fetch("/api/billing/status", { credentials: "include", cache: "no-store" })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => { if (mounted) { setActive(data?.active === true); setChecking(false); } })
      .catch(() => { if (mounted) setChecking(false); });
    return () => { mounted = false; };
  }, [loading, user]);
  if (loading || checking) return <div className="estado-pagina">Verificando assinatura…</div>;
  if (!user) return <Navigate to="/entrar" replace />;
  if (!active) return <Navigate to="/app/plano" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<div className="estado-pagina">Carregando…</div>}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/mapa-pressao-arterial" element={<SeoToolPage />} />
            <Route path="/mapa-glicemico" element={<SeoToolPage />} />
            <Route path="/diario-de-cefaleia" element={<SeoToolPage />} />
            <Route path="/mrpa" element={<SeoToolPage />} />
            <Route path="/entrar" element={<Login />} />
            <Route path="/ativar" element={<Ativar />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route path="/paciente" element={<Paciente />} />
            <Route path="/privacidade" element={<Legal tipo="privacidade" />} />
            <Route path="/termos" element={<Legal tipo="termos" />} />
            <Route path="/app" element={<Protected><PlanRequired><Dashboard /></PlanRequired></Protected>} />
            <Route path="/app/novo" element={<Protected><PlanRequired><NovoDiario /></PlanRequired></Protected>} />
            <Route path="/app/acompanhamentos/:id" element={<Protected><PlanRequired><Acompanhamento /></PlanRequired></Protected>} />
            <Route path="/app/plano" element={<Protected><Plano /></Protected>} />
            <Route path="/app/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}
